import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import breakpoints from '../Theme/breakpoints';
import Skeleton from './Skeleton';

const CardWithTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 2rem;
`;

export const CardImage = styled(Skeleton)`
  min-height: 66vw;

  @media (min-width: ${breakpoints.md}px) {
    min-height: 22vw;
  }

  @media (min-width: ${breakpoints.lg}px) {
    min-height: 12vw;
  }
`;

interface CardWithTextSkeletonProperties {
  children?: ReactNode;
}

const CardWithTextSkeleton = ({
  children,
}: CardWithTextSkeletonProperties) => (
  <CardWithTextContainer>
    <CardImage
      animation="wave"
      variant="rectangular"
    />
    {children}
  </CardWithTextContainer>
);

export default CardWithTextSkeleton;
